export default "__VITE_ASSET__18695c2c__"